


Your Performance:
<app-dash>...</app-dash>

 <h4> Mistake Types: </h4>
 
<app-mistake-type-rpt >...</app-mistake-type-rpt>
